document.addEventListener("DOMContentLoaded", function () {
  const components = document.querySelectorAll("product-media-variants");
  if (!components.length) return;

  components.forEach((container) => {
    const productId = container.dataset.id;
    const initialVariantId = container.dataset.initialVariantId;

    const jsonElement = document.getElementById(`VariantExtraImages-${productId}`);
    if (!jsonElement) return;

    let variantImageMap = {};
    try {
      const parsedData = JSON.parse(jsonElement.textContent);
      parsedData.variants.forEach((v) => {
        variantImageMap[v.id] = v.images || [];
      });
    } catch (e) {
      console.warn("Unable to parse Variant Extra Images JSON", e);
    }

    const renderExtraImages = (variantId) => {
      const containerEl = container.querySelector(".product-media--container");
      if (!containerEl) return;

      containerEl.querySelectorAll("[data-extra-variant-media='true']").forEach((el) => el.remove());

      const imgs = variantImageMap[variantId];
      if (!imgs || !imgs.length) return;

      imgs.forEach((img, idx) => {
        const wrapper = document.createElement("div");
        wrapper.className = "product-media--root";
        wrapper.dataset.active = idx === 0 ? "true" : "false";
        wrapper.dataset.id = img.id;
        wrapper.dataset.extraVariantMedia = "true";

        const imageTag = document.createElement("img");
        imageTag.src = img.src;
        imageTag.loading = "lazy";
        wrapper.appendChild(imageTag);

        containerEl.appendChild(wrapper);
      });
    };

    const handleVariantEvent = (event) => {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;
      renderExtraImages(variant.id);
    };

    document.addEventListener(`theme:product:${productId}:variantChange`, handleVariantEvent);
    document.addEventListener(`theme:product:${productId}:variantChanged`, handleVariantEvent);

    if (initialVariantId) {
      renderExtraImages(Number(initialVariantId));
    }
  });
});
